export const HOME_CONST=[
    { label:'Web Development',color:'red'},
    { label:'Custom Development',color:'green'},
    { label:'Mobile app Development',color:'blue'},
    { label:'Cloud Support',color:'purple'},
    { label:'DevOps',color:'yellow'},
    { label:'Machine Learning',color:'grey'},
    { label:'Web Design',color:'pink'},

]